<script>
import CommonService from '../../services/common';
import Service from '../../services/vessel-protocol';
import CommonConstants from '../../common/Constants';
import config from '../../common/genericPanelConf';
import Utils from '../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
// import GenericDataTable from '../../components/generic/GenericDataTable.vue'

export default{
  props: ['id'],
  components: {
    ResponsiveButton,
        // GenericDataTable
  },
  data(){
    return {
      loading: false,
      detail: {},
      logs: [],
      documents: [],
      uploadVisible: false,
      itemUpload: null,

      originSamplesStatuses: [
        {
          label: 'Missing',
          value: false
        },
        {
          label: 'Present',
          value: true
        }
      ],
      genericStatuses: [
        {
          label: 'ToBeValidated',
          value: 'ToBeValidated'
        },
        {
          label: 'Valid',
          value: 'Valid'
        },
        {
          label: 'NotValid',
          value: 'NotValid'
        }
      ]
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.configuration = config.getConfiguration('DischargeTrackingReport');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'DischargeTrackingReport.page_title');
    this.load();
  },
  methods: {
     load(){
      CommonService.loadGenericItem(this.configuration.api, this.id, response => {
        if(response.success){
            this.detail = response.data;
            this.detail.referenceDate = Utils.dateToCurrentTimeZone(response.data.referenceDate);
            this.detail.laycanStartDate = Utils.dateToCurrentTimeZone(response.data.laycanStartDate);
            this.detail.laycanEndDate = Utils.dateToCurrentTimeZone(response.data.laycanEndDate);
            this.generateDocuments();
        }else{
            this.detail = {};
        }
      });

      this.logs = [];
      CommonService.loadGenericItem('vessel-protocol-discharge-tracking-log', this.id, response => {
        if(response.success){
            this.logs = response.data;
        }else{
            this.logs = [];
        }
      });
    },
    generateDocuments(){
      this.loading = true;

      this.documents = [];
      this.documents.push({
        name: 'certificateOfOriginStatus',
        status: this.detail.certificateOfOriginStatus,
        uploadBtn: 'dischargeTrackingCertificateOfOriginUploadBtn',
        validateBtn: 'dischargeTrackingCertificateOfOriginBtn',
        documentGuid: this.detail.certificateOfOriginDocumentGuid,
        fileNameWithExtension: this.detail.certificateOfOriginDocumentFileNameWithExtension,
        documentType: 'Certificato di origine',
        showUpload: true,
        field: 'certificateOfOriginStatus'
      });

      if(this.detail.isSuppliersDeclarationMandatory){
        this.documents.push({
          name: 'suppliersDeclarationStatus',
          status: this.detail.suppliersDeclarationStatus,
          uploadBtn: 'dischargeTrackingSuppliersDeclarationUploadBtn',
          validateBtn: 'dischargeTrackingSuppliersDeclarationBtn',
          documentGuid: this.detail.suppliersDeclarationDocumentGuid,
          fileNameWithExtension: this.detail.suppliersDeclarationDocumentFileNameWithExtension,
          documentType: 'Dichiarazione del fornitore',
          showUpload: true,
          field: 'suppliersDeclarationStatus'
        });
      }

      if(this.detail.isExportDeclarationMandatory){
        this.documents.push({
          name: 'exportDeclarationStatus',
          status: this.detail.exportDeclarationStatus,
          uploadBtn: 'dischargeTrackingExportDeclarationUploadBtn',
          validateBtn: 'dischargeTrackingExportDeclarationBtn',
          documentGuid: this.detail.exportDeclarationDocumentGuid,
          fileNameWithExtension: this.detail.exportDeclarationDocumentFileNameWithExtension,
          documentType: 'Dichiarazione di esportazione',
          showUpload: true,
          field: 'exportDeclarationStatus'
        });
      }

      if(this.detail.isNonManipulationDeclarationMandatory){
        this.documents.push({
          name: 'nonManipulationDeclarationStatus',
          status: this.detail.nonManipulationDeclarationStatus,
          uploadBtn: 'dischargeTrackingNonManipulationDeclarationUploadBtn',
          validateBtn: 'dischargeTrackingNonManipulationDeclarationBtn',
          documentGuid: this.detail.nonManipulationDeclarationDocumentGuid,
          fileNameWithExtension: this.detail.nonManipulationDeclarationDocumentFileNameWithExtension,
          documentType: 'Dichiarazione di non manipolazione',
          showUpload: true,
          field: 'nonManipulationDeclarationStatus'
        });
      }
      this.documents.push({
        name: 'voyageReportStatus',
        status: this.detail.voyageReportStatus,
        uploadBtn: 'dischargeTrackingVoyageReportUploadBtn',
        validateBtn: 'dischargeTrackingVoyageReportBtn',
        documentGuid: this.detail.voyageReportDocumentGuid,
        fileNameWithExtension: this.detail.voyageReportDocumentFileNameWithExtension,
        documentType: 'Voyage Report',
        showUpload: true,
        field: 'voyageReportStatus'
      });
      this.documents.push({
        name: 'letterOfProtestSamplesStatus',
        status: this.detail.letterOfProtestSamplesStatus,
        uploadBtn: 'dischargeTrackingLetterOfProtestSamplesUploadBtn',
        validateBtn: 'dischargeTrackingLetterOfProtestSamplesStatusBtn',
        documentGuid: this.detail.letterOfProtestSamplesDocumentGuid,
        fileNameWithExtension: this.detail.letterOfProtestSamplesDocumentFileNameWithExtension,
        documentType: 'Letter Of Protest (Samples)',
        showUpload: true,
        field: 'letterOfProtestSamplesStatus'
      });
      /*this.documents.push({
        name: 'letterOfProtestFromMasterStatus',
        status: this.detail.letterOfProtestFromMasterStatus,
        uploadBtn: 'dischargeTrackingLetterOfProtestFromMasterUploadBtn',
        validateBtn: 'dischargeTrackingLetterOfProtestFromMasterStatusBtn',
        documentGuid: this.detail.letterOfProtestFromMasterDocumentGuid,
        fileNameWithExtension: this.detail.letterOfProtestFromMasterDocumentFileNameWithExtension,
        documentType: 'Letter Of Protest From Master',
        showUpload: true,
        field: 'letterOfProtestFromMasterStatus'
      });*/
      if(this.detail.isReceiptOfDocumentsAndSamplesMandatory){
        this.documents.push({
          name: 'receiptOfDocumentsAndSamplesStatus',
          status: this.detail.receiptOfDocumentsAndSamplesStatus,
          uploadBtn: 'dischargeTrackingReceiptOfDocumentsAndSamplesUploadBtn',
          validateBtn: 'dischargeTrackingReceiptOfDocumentsAndSamplesBtn',
          documentGuid: this.detail.receiptOfDocumentsAndSamplesDocumentGuid,
          fileNameWithExtension: this.detail.receiptOfDocumentsAndSamplesDocumentFileNameWithExtension,
          documentType: 'Ricevuta documenti e campioni',
          showUpload: true,
          field: 'receiptOfDocumentsAndSamplesStatus'
        });
      }
      this.documents.push({
        name: 'isOriginSamplePresent',
        status: this.detail.isOriginSamplePresent ? 'Present' : 'Missing',
        validateBtn: 'dischargeTrackingOriginSamplePresentBtn',
        showUpload: false,
        toValidate: true,
        isOriginSample: true
      });
      this.loading = false;
    },
    uploadDocument(item){
      this.itemUpload = item;
      this.uploadVisible = true;
    },
    downloadDocument({documentGuid, fileNameWithExtension}){
      if (documentGuid == null || documentGuid == "" || fileNameWithExtension == null || fileNameWithExtension == ""){
        this.$toast.add({ detail: this.$t('messages.documentDownloadCorruptedMessage'), life: 3000, severity: 'error' });
      } else {
        this.$store.dispatch("generic/setLoading", true);
        Service.downloadDocumentVesselProtocol({documentGuid: documentGuid, fileNameWithExtension }, ({success, data, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          
          if(success){
            var fileURL = window.URL.createObjectURL(new Blob([data]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', fileNameWithExtension);
            document.body.appendChild(fileLink);
        
            fileLink.click();
          } else{
            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
      }
    },
    onUpload(file){
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
      });
      file.files.forEach( async (document) => {
        const base64 = await toBase64(document);

        let formData = {
          idVesselProtocol: this.detail.idVesselProtocol,
          section: 'DischargeTracking',
          description: document.name,
          documentType: this.itemUpload.documentType,
          fileNameWithExtension: document.name,
          fileContentBase64: base64,
        }
        this.$store.dispatch("generic/setLoading", true);
  
        Service.addDocumentVesselProtocolDocumentManager(formData, ({success, data, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          if(success){
            this.uploadVisible = false;
            this.itemUpload = null;
            this.$toast.add({detail: this.$t('messages.upload_message_success'), life:3000, severity:'success'});
            this.load();
          }else{
            this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
      })
    },
    saveDocumentStatus(item){
      this.$confirm.require({
          message: this.$t('DischargeTrackingReport.changeStatusMessage'),
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: this.$t('yes'),
          rejectLabel: this.$t('no'),
          accept: () => {
            let body = {
              id: this.detail.id,
              documentType: item.documentType,
              documentStatus: this.detail[item.field]
            };

            CommonService.updateItem('vessel-protocol-discharge-tracking-doc-status', body, response => {
              if(response.success){
                  this.load();
              }else{
                this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
              }
            });
          },
          reject: () => {
              //callback to execute when user rejects the action
              this.load();
              this.$confirm.close();
          }
      });
    },
    saveOriginSamplePresent(item){

      this.$confirm.require({
        message: this.$t('DischargeTrackingReport.changeStatusMessage'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
          let body = {
            id: this.detail.id,
            isOriginSamplePresent: this.detail.isOriginSamplePresent
          };

          CommonService.updateItem('vessel-protocol-discharge-tracking-origin-sample-status', body, response => {
            if(response.success){
                this.load();
            }else{
              this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
          });
        },
        reject: () => {
            //callback to execute when user rejects the action
            this.load();
            this.$confirm.close();
        }
      });

    }
  }
}

</script>

<template>
  <main>
     <Dialog v-model:visible="uploadVisible" modal>
        <template #header>
            <h3>{{$t('DischargeTrackingReport.upload')}}</h3>
        </template>
        <FileUpload name="uploaded[]" :customUpload="true" @uploader="onUpload" :previewWidth="0" :fileLimit="1" :multiple="false" />                    
    </Dialog>   
    <div class="grid">
      <div class="col-12 lg:col-3 field">
        <label for="referenceDate">{{$t('vesselProtocol.referenceDate')}}</label>
        <Calendar :placeholder="constants.DATE_PLACEHOLDER_POINT"
          :dateFormat="constants.DATE_FORMAT_POINT"
          :showTime="true"
          readonly
          id="laycanFrom" 
          v-model="detail.referenceDate"
          :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-12 lg:col-3 field">
        <label for="voyageNumber">{{$t('movementInstructions.voyageNumber')}}</label>
        <InputText readonly id="voyageNumber" type="text" v-model="detail.voyageNumber" :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-12 lg:col-3 field">
        <label for="lotCode">{{$t('movementInstructionLots.lotCode')}}</label>
        <InputText readonly id="lotCode" type="text" v-model="detail.lotCode" :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-12 lg:col-3 field">
        <label for="plant">{{$t('registryPlant.fk')}}</label>
        <InputText readonly id="plant" type="text" v-model="detail.plant" :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-12 lg:col-3 field">
        <label for="product">{{$t('product.fk')}}</label>
        <InputText readonly id="product" type="text" v-model="detail.product" :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-12 lg:col-3 field">
        <label for="origin">{{$t('vesselProtocol.originCountryProduct')}}</label>
        <InputText readonly id="origin" type="text" v-model="detail.origin" :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-12 lg:col-3 field">
        <label for="loadingPort">{{$t('DischargeTrackingReport.loadingPort')}}</label>
        <InputText readonly id="loadingPort" type="text" v-model="detail.loadingPort" :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-12 lg:col-3 field">
        <label for="dischargePort">{{$t('DischargeTrackingReport.dischargePort')}}</label>
        <InputText readonly id="dischargePort" type="text" v-model="detail.dischargePort" :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-12 lg:col-3 field">
        <label for="vesselName">{{$t('vessel.fk')}}</label>
        <InputText readonly id="vesselName" type="text" v-model="detail.vesselName" :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-12 lg:col-3 field">
        <label for="laycanStartDate">{{$t('movementInstructions.laycanFrom')}}</label>
        <Calendar :placeholder="constants.DATE_PLACEHOLDER_POINT"
          :dateFormat="constants.DATE_FORMAT_POINT"
          :showTime="true"
         readonly
          id="laycanStartDate" 
          v-model="detail.laycanStartDate"
          :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-12 lg:col-3 field">
        <label for="laycanEndDate">{{$t('movementInstructions.laycanTo')}}</label>
        <Calendar :placeholder="constants.DATE_PLACEHOLDER_POINT"
          :dateFormat="constants.DATE_FORMAT_POINT"
          :showTime="true"
         readonly
          id="laycanEndDate" 
          v-model="detail.laycanEndDate"
          :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>

      <div class="col-12">
        <DataTable :value="documents" :reorderableColumns="true" :loading="loading">
          <Column :exportable="false" style="width:20%">
            <template #body="slotProps" >
              <ResponsiveButton icon="pi pi-download" v-tooltip="$t('btn.download')" class="p-button-rounded p-button-outlined" @click="downloadDocument(slotProps.data)" v-if="slotProps.data.showUpload && slotProps.data.documentGuid" />
              <ResponsiveButton icon="pi pi-upload" v-tooltip="$t('DischargeTrackingReport.upload')" class="mx-1 p-button-rounded p-button-outlined" @click="uploadDocument(slotProps.data)" v-if="slotProps.data.showUpload && uiPermissions(slotProps.data.uploadBtn).isEnabled" />
            </template>
          </Column>
          <Column field="document" :header="$t('DischargeTrackingReport.document')">
            <template #body="{data}">
              {{data.name ? $t('DischargeTrackingReport.' + data.name) : ''}}
            </template>
          </Column>
          <Column field="status" :header="$t('DischargeTrackingReport.documentStatus')">
            <template #body="{data}">
              <span v-if="data.isOriginSample">
                <Dropdown v-model="detail.isOriginSamplePresent" :options="originSamplesStatuses" optionLabel="label" optionValue="value" class="w-full md:w-14rem">
                  <template #value="slotProps">
                    <div class="flex align-items-center">
                        <div>{{ slotProps.value ?  $t('DischargeTrackingReport.status.Present') : $t('DischargeTrackingReport.status.Missing')}}</div>
                    </div>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center">
                        <div>{{ $t('DischargeTrackingReport.status.' + slotProps.option.label) }}</div>
                    </div>
                </template>
                </Dropdown>
                <ResponsiveButton icon="pi pi-save" v-tooltip="$t('btn.save')" class="p-button-rounded p-button-outlined mx-2" @click="saveOriginSamplePresent(data)" v-if="uiPermissions(data.validateBtn).isEnabled" />

              </span>
              <span v-else-if="data.status != 'Missing'">
                <Dropdown v-model="detail[data.field]" :options="genericStatuses" optionLabel="label" optionValue="value" class="w-full md:w-14rem">
                  <template #value="slotProps">
                    <div class="flex align-items-center">
                        <div>{{ $t('DischargeTrackingReport.status.' + slotProps.value) }}</div>
                    </div>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center">
                        <div>{{ $t('DischargeTrackingReport.status.' + slotProps.option.label) }}</div>
                    </div>
                </template>
                </Dropdown>
                <ResponsiveButton icon="pi pi-save" v-tooltip="$t('btn.save')" class="p-button-rounded p-button-outlined mx-2" @click="saveDocumentStatus(data)" v-if="uiPermissions(data.validateBtn).isEnabled" />

              </span>
              <span v-else>
                {{data.status ? $t('DischargeTrackingReport.status.' + data.status) : ''}}
              </span>
            </template>
          </Column>
        </DataTable>
      </div>
      <div class="col-12">
        <Panel header="Log" toggleable>
        <DataTable :value="logs" :reorderableColumns="true" :loading="loading">
          <Column field="logDate" :header="$t('DischargeTrackingReport.logDate')">
            <template #body="{data}">
              {{data.logDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data.logDate)) : null}}
            </template>
          </Column>
          <Column field="username" :header="$t('user_roles.user')">
            <template #body="{data}">
              {{data.username}}
            </template>
          </Column>
          <Column field="logEntry" :header="$t('DischargeTrackingReport.logEntry')">
            <template #body="{data}">
              {{data.logEntry}}
            </template>
          </Column>
        </DataTable>
        </Panel>
      </div>
    </div>
  </main>
</template>